const INSURANCE_ID = 57537318322524;
const PREMIUM_ATTENTION_ID = 58094707376476;
const EXTENDED_RETURN_ID = 58094709670236;
/* =========================================================
   PRECIOS DINÁMICOS DE PROTECCIÓN
   ========================================================= */

const PROTECTION_PRODUCTS = {
  insurance: {
    handle: 'seguro-de-envio',
    variantId: INSURANCE_ID
  },
  premium: {
    handle: 'atencion-premium',
    variantId: PREMIUM_ATTENTION_ID
  }
};


function formatProtectionPrice(priceInSubunits, currency) {
  const amount = Number(priceInSubunits) / 100;

  if (!Number.isFinite(amount)) {
    return '';
  }

  try {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'es-ES',
      {
        style: 'currency',
        currency: currency
      }
    ).format(amount);

  } catch (error) {
    return amount.toFixed(2) + ' ' + currency;
  }
}


function updateProtectionPrice(service, formattedPrice) {

  document
    .querySelectorAll(
      '[data-service-price="' + service + '"]'
    )
    .forEach(element => {
      element.textContent = '+ ' + formattedPrice;
    });

}


async function loadProtectionPrices() {

  try {

    const cart = await getCart();

    const currency =
      cart.currency ||
      window.Shopify?.currency?.active ||
      'EUR';


    const [insuranceRes, premiumRes] = await Promise.all([

      fetch(
        '/products/' +
        PROTECTION_PRODUCTS.insurance.handle +
        '.js',
        {
          credentials: 'same-origin'
        }
      ),

      fetch(
        '/products/' +
        PROTECTION_PRODUCTS.premium.handle +
        '.js',
        {
          credentials: 'same-origin'
        }
      )

    ]);


    if (!insuranceRes.ok || !premiumRes.ok) {
      throw new Error(
        'No se pudieron cargar los productos de protección'
      );
    }


    const insuranceProduct = await insuranceRes.json();
    const premiumProduct = await premiumRes.json();


    const insuranceVariant =
      insuranceProduct.variants.find(
        variant =>
          Number(variant.id) ===
          Number(PROTECTION_PRODUCTS.insurance.variantId)
      ) || insuranceProduct.variants[0];


    const premiumVariant =
      premiumProduct.variants.find(
        variant =>
          Number(variant.id) ===
          Number(PROTECTION_PRODUCTS.premium.variantId)
      ) || premiumProduct.variants[0];


    if (insuranceVariant) {

      updateProtectionPrice(
        'insurance',
        formatProtectionPrice(
          insuranceVariant.price,
          currency
        )
      );

    }


    if (premiumVariant) {

      updateProtectionPrice(
        'premium',
        formatProtectionPrice(
          premiumVariant.price,
          currency
        )
      );

    }

  } catch (error) {

    console.error(
      'Error cargando precios de protección:',
      error
    );

  }

}
let isProcessing = false;

/*
 * Origen del añadido (28/10/2026): se guarda en la línea como propiedad oculta
 * "_origen" (popup / drawer / cesta) para medir qué sitio vende cada protección.
 * Las propiedades que empiezan por "_" no se muestran a la clienta.
 */
function protectionSource(el) {
  if (!el || !el.closest) return 'desconocido';
  if (el.closest('#lila-popup-flow')) return 'popup';
  if (el.closest('cart-drawer, #cart-drawer')) return 'drawer';
  if (window.location.pathname.includes('/cart')) return 'cesta';
  return 'otro';
}

async function getCart() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  return await res.json();
}

async function addItem(variantId, source) {
  const cart = await getCart();

  const exists = cart.items.some(
    i => Number(i.variant_id) === Number(variantId)
  );

  if (exists) return;

  const params = new URLSearchParams({
    id: variantId,
    quantity: 1
  });

  if (source) {
    params.append('properties[_origen]', source);
  }

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: params
  });

  if (!res.ok) {
    throw new Error(
      `No se pudo añadir la variante ${variantId} al carrito`
    );
  }

  return await res.json();
}

async function removeItemByVariantId(variantId) {
  const cart = await getCart();

  const item = cart.items.find(
    i => Number(i.variant_id) === Number(variantId)
  );

  if (!item) return;

  const res = await fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: item.key,
      quantity: 0
    })
  });

  if (!res.ok) {
    throw new Error(
      `No se pudo eliminar la variante ${variantId} del carrito`
    );
  }

  return await res.json();
}

async function refreshCartUI() {
  if (window.location.pathname.includes('/cart')) {
    window.location.reload();
    return;
  }

  const cart = await getCart();

  ['cart:refresh', 'cart:updated', 'ajaxProduct:added'].forEach(name => {
    document.dispatchEvent(
      new CustomEvent(name, { bubbles: true, detail: cart })
    );
  });
}

async function syncCartServices() {
  if (isProcessing) return;

  const cart = await getCart();

  const hasInsurance = cart.items.some(i => Number(i.variant_id) === Number(INSURANCE_ID));
  const hasPremium = cart.items.some(i => Number(i.variant_id) === Number(PREMIUM_ATTENTION_ID));
  const hasExtendedReturn = cart.items.some(i => Number(i.variant_id) === Number(EXTENDED_RETURN_ID));

  document.querySelectorAll('#cart-insurance-option').forEach(input => {
    input.checked = hasInsurance && !hasPremium;
  });

  document.querySelectorAll('#cart-premium-attention-option').forEach(input => {
    input.checked = hasPremium;
  });

  document.querySelectorAll('#cart-extended-return-option').forEach(input => {
    input.checked = hasExtendedReturn;
  });

  updateSelectedCards();
}

function updateSelectedCards() {
  document.querySelectorAll('.cart-service-card, .cart-extended-return').forEach(card => {
    card.classList.remove('is-selected');
  });

  document.querySelectorAll('#cart-insurance-option').forEach(input => {
    if (input.checked) {
      input.closest('.cart-service-card')?.classList.add('is-selected');
    }
  });

  document.querySelectorAll('#cart-premium-attention-option').forEach(input => {
    if (input.checked) {
      input.closest('.cart-service-card')?.classList.add('is-selected');
    }
  });

  document.querySelectorAll('#cart-extended-return-option').forEach(input => {
    if (input.checked) {
      input.closest('.cart-extended-return')?.classList.add('is-selected');
    }
  });
}

async function handleProtectionOption(value, box, redirectToCart = false) {
  if (isProcessing) return;

  isProcessing = true;

  const source = protectionSource(box);

  if (box) {
    box.classList.add('is-loading');
  }

  try {

    if (value === 'insurance') {
      await removeItemByVariantId(PREMIUM_ATTENTION_ID);
      await addItem(INSURANCE_ID, source);
    }

    if (value === 'premium') {
      await removeItemByVariantId(INSURANCE_ID);
      await addItem(PREMIUM_ATTENTION_ID, source);
    }

    /*
     * Si viene del popup:
     * una vez añadido correctamente → ir a la cesta.
     */
    if (redirectToCart) {
      window.location.href = '/cart';
      return;
    }

    /*
     * Comportamiento normal para cualquier otro sitio
     * donde usemos estas opciones.
     */
    await refreshCartUI();

  } catch (error) {

    console.error(
      'Error actualizando servicios del carrito:',
      error
    );

  } finally {

    isProcessing = false;

    if (box) {
      box.classList.remove('is-loading');
    }

    /*
     * Si estamos redirigiendo no necesitamos
     * resincronizar la interfaz actual.
     */
    if (!redirectToCart) {
      await syncCartServices();
    }
  }
}

async function handleExtendedReturn(isChecked, box) {
  if (isProcessing) return;

  isProcessing = true;

  if (box) {
    box.classList.add('is-loading');
  }

  try {

    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [EXTENDED_RETURN_ID]: isChecked ? 1 : 0
        }
      })
    });

    await refreshCartUI();

  } catch (error) {
    console.error('Error actualizando devolución extendida:', error);

  } finally {
    isProcessing = false;

    if (box) {
      box.classList.remove('is-loading');
    }

    await syncCartServices();
  }
}

document.addEventListener('change', (e) => {
  const target = e.target;
  const box = target.closest('.cart-services-box');

  if (target?.name === 'cart-protection-option') {
    handleProtectionOption(target.value, box);
  }

  if (target?.id === 'cart-extended-return-option') {
    handleExtendedReturn(target.checked, box);
  }
});

document.addEventListener('cart:refresh', () => {
  if (!isProcessing) {
    syncCartServices();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  syncCartServices();
  loadProtectionPrices();
});

document.addEventListener('click', (e) => {

  const protectionButton = e.target.closest(
    '[data-cart-protection-option]'
  );

  const extendedReturnButton = e.target.closest(
    '[data-cart-extended-return]'
  );


  /* =========================================================
     PROTECCIÓN / PROTECCIÓN PLUS
     ========================================================= */

  if (protectionButton) {

    e.preventDefault();

    const box = protectionButton.closest(
      '.cart-services-box'
    );

    const shouldRedirect =
      protectionButton.hasAttribute(
        'data-cart-protection-redirect'
      );

    handleProtectionOption(
      protectionButton.dataset.cartProtectionOption,
      box,
      shouldRedirect
    );
  }


  /* =========================================================
     DEVOLUCIÓN EXTENDIDA
     ========================================================= */

  if (extendedReturnButton) {

    e.preventDefault();

    const box = extendedReturnButton.closest(
      '.cart-services-box'
    );

    const isSelected =
      extendedReturnButton.classList.contains(
        'is-selected'
      );

    handleExtendedReturn(
      !isSelected,
      box
    );
  }

});

const drawerObserver = new MutationObserver(() => {

  const box = document.querySelector('.cart-services-box');

  if (!box || isProcessing) return;


  setTimeout(() => {

    syncCartServices();

    /*
     * Si han aparecido elementos de precio
     * todavía vacíos, cargamos los precios.
     */
    const emptyPrices = document.querySelector(
      '[data-service-price]:empty'
    );

    if (emptyPrices) {
      loadProtectionPrices();
    }

  }, 150);

});

drawerObserver.observe(document.body, {
  childList: true,
  subtree: true
});